import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import { Ticket } from "../../../models/Ticket";
import getId from "../../../../utils/getId";
import { HiOutlineTicket } from "react-icons/hi";
import EAButton from "../../shared/Buttons/EAButton";
import "./style.scss";
import EAChip from "../../shared/Chip/EAChip";
import { calculateRemainingEntrances, isValidityEndingSoon } from "../../../utils/TicketPassHelper";
import { differenceInDays } from "date-fns";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";

interface IProps {
  passesList: Ticket[];
  loading: boolean;
  joinToExercise: (value: boolean, passId: string) => void;
  reservationList: boolean;
  exerciseStart: number;
  hasNoSpaces: boolean;
}

const ExerciseInfoPassSelector: React.FC<IProps> = ({
  passesList,
  loading,
  joinToExercise,
  reservationList,
  exerciseStart,
  hasNoSpaces,
}) => {
  const { t } = useTranslation();
  const [showOptions, setShowOptions] = useState(false);
  const isDesktop = useDesktopSize();

  const handleClickInOption = (value: boolean, id: string) => {
    joinToExercise(value, id);
    setShowOptions(false);
  };

  const getFilteredPassesList = () => {
    const filteredPassesList = passesList.filter(
      (item) => item.validfrom <= exerciseStart && exerciseStart <= item.validto,
    );
    return filteredPassesList;
  };

  const getChipForPass = (pass: Ticket) => {
    if (calculateRemainingEntrances(pass) <= 0) {
      return <EAChip label="Wyczerpano" variant="error" />;
    }
    if (isValidityEndingSoon(pass)) {
      return <EAChip label={`Wygasa za ${differenceInDays(pass.validto, new Date())} dni`} variant="warning" />;
    }
    return null;
  };

  return (
    <LoadableComponent loading={loading}>
      {getFilteredPassesList().length > 1 ? (
        <>
          <div className="exercise-pass-dropdown">
            <EAButton
              title={reservationList ? t("zapisz_sie_na_liste_rezerwowa") : t("zapisz_sie_karnetem")}
              disabled={hasNoSpaces && !reservationList}
              onClick={() => setShowOptions(!showOptions)}
              endIcon={showOptions ? <IoIosArrowDown /> : <IoIosArrowUp />}
              variant="filled"
              fullWidth
            />
            {showOptions && (
              <ul className="exercise-pass-dropdown__list">
                {getFilteredPassesList().map((option) => (
                  <>
                    {option.ticket === false && (
                      <li
                        className="exercise-pass-dropdown__item"
                        key={getId(option)}
                        onClick={() => handleClickInOption(false, getId(option))}
                      >
                        <div className="exercise-pass-dropdown__item-label">
                          <HiOutlineTicket className="exercise-pass-dropdown__item-icon" />
                          <p>{option.name}</p>
                        </div>

                        {getChipForPass(option)}
                      </li>
                    )}
                  </>
                ))}
              </ul>
            )}
          </div>
        </>
      ) : (
        <EAButton
          title={reservationList ? t("zapisz_sie_na_liste_rezerwowa") : t("zapisz_sie_karnetem")}
          disabled={hasNoSpaces && !reservationList}
          onClick={() => joinToExercise(false, "null")}
          endIcon={<AiOutlineUserAdd />}
          variant="filled"
          fullWidth
        />
      )}
      {isDesktop && (
        <span className="caption text-color-light-gray text-centered">
          {reservationList ? t("opis_listy_rezerwowej_karnet") : t("lub jeżeli nie masz karnetu")}
        </span>
      )}
    </LoadableComponent>
  );
};

export default ExerciseInfoPassSelector;
